import { render, staticRenderFns } from "./login-sidebar.vue?vue&type=template&id=63bc7b06&"
import script from "./login-sidebar.vue?vue&type=script&lang=js&"
export * from "./login-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./login-sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports